<template>
    <div style="height: 100%">
        <div class="home-head home-head-page">
            <TopHeader></TopHeader>
        </div>
        <div class="abouts">
            <div class="about-content">
                <div class="content-box">
                    <div class="title-name">关 于 我 们</div>
                    <div class="content-info">
                        <div class="info">
                            <p class="info-aircraft"></p>
                            <p class="info-content">民 航 人 工 智 能 领 域 引 领 者</p>
                        </div>
                        <div class="info" style="margin-top: 20px">
                            <p class="info-aircraft"></p>
                            <p class="info-content"><span>掌 握 </span><span style="color: rgb(248,78,32)">国 内 第 一 、 全 球 领
                                    先 </span> <span> 的 民 航 领 域 语 音 识 别 技 术</span></p>
                        </div>
                        <div class="info" style="margin-top: 20px">
                            <p class="info-aircraft"></p>
                            <p class="info-content" style="width: 212px">服 务 民 航 头 部 客 户 : </p>
                            <p style="width: 533px;margin-left: 8px;font-weight: 700">南 方 航 空、上 海 机 场 集 团、首 都 机 场 集 团、 民
                                航 华 东 空 管 局、中 南 空 管 局 等
                            </p>
                        </div>
                        <div class="info" style="margin-top: 20px">
                            <p class="info-aircraft"></p>
                            <p class="info-content" style="min-width: 140px">我 们 的 愿 景 : </p>
                            <p>立 足 中 国，放 眼 全 球，依 托 Al，覆 盖 技 术 服 务、装 备 生 产、
                                民 航 培 训 等 多 领 域，构 建 航 空 先 进 技 术 集 团</p>
                        </div>
                        <div class="title-partner">合 作 伙 伴</div>
                        <div class="partner-info">
                            <div>
                                <div class="img1"></div>
                            </div>
                            <div>
                                <div class="img2"></div>
                            </div>
                            <div>
                                <div class="img3"></div>
                            </div>
                            <div>
                                <div class="img4"></div>
                            </div>
                        </div>
                        <div class="partner-info" style="margin-top: 0">
                            <div>
                                <div class="img5"></div>
                            </div>

                            <div>
                                <div class="img7"></div>
                            </div>
                            <div>
                                <div class="img8"></div>
                            </div>
                            <div>
                                <div class="img6"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="newFootSet">
            <Footer class="special-foot"></Footer>
        </div>
    </div>
</template>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;
}
.abouts {
  color: #000000;
  height: calc(100% - 164px) !important;
  min-height: 736px;
  @include centerLine;
}
.about-content{
  width: 800px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .info-aircraft{
    min-width: 33px;
    height: 33px;
    background: url("../assets/xfj.png") no-repeat;
  }

  .partner-info{
    padding: 0 30px;
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .img-title{
      text-align: center;
      font-size: 16px;
      margin-top: 12px;
    }
    .img1{
      background: url("../../../common/commonImages/hdkg.png") no-repeat;
      width: 120px;
      height: 120px;
      background-size: 100% 100%;
      &:hover{
        background: url("../../../common/commonImages/hdkgH.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    .img2{
      background: url("../../../common/commonImages/znkg.png") no-repeat;
      width: 120px;
      height: 120px;
      background-size: 100% 100%;
      &:hover{
        background: url("../../../common/commonImages/znkgH.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    .img3{
      background: url("../../../common/commonImages/shjc.png") no-repeat;
      width: 120px;
      height: 120px;
      background-size: 100% 100%;
      &:hover{
        background: url("../../../common/commonImages/shjcH.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    .img4{
      background: url("../../../common/commonImages/ytgj.png") no-repeat;
      width: 120px;
      height: 120px;
      background-size: 100%;
      &:hover{
        background: url("../../../common/commonImages/ytgjH.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    .img5{
      background: url("../../../common/commonImages/qdjd.png") no-repeat;
      width: 120px;
      height: 120px;
      background-size: 100% 100%;
      &:hover{
        background: url("../../../common/commonImages/qdjdH.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    .img6{
    //   background: url("../../../common/commonImages/zgmh.png") no-repeat;
      width: 120px;
      height: 120px;
      background-size: 100% 100%;
      &:hover{
        // background: url("../../../common/commonImages/zgmhH.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    .img7{
      background: url("../../../common/commonImages/zdk.png") no-repeat;
      width: 120px;
      height: 120px;
      background-size: 100% 100%;
      &:hover{
        background: url("../../../common/commonImages/zdkH.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    .img8{
      background: url("../../../common/commonImages/mhj.png") no-repeat;
      width: 120px;
      height: 120px;
      background-size: 100%;
      &:hover{
        background: url("../../../common/commonImages/mhjH.png") no-repeat;
        background-size: 100% 100%;
      }
    }
  }
  .title-partner{
    color: rgb(248,78,32);
    font-size: 28px;
    text-align: center;
    margin-top: 40px;
  }
  .info-content{
    margin-left: 20px;
  }
  .content-box{
    .content-info{
      margin-top: 40px;
      font-size: 18px;
      color: rgb(100,100,100);
      .info{
        display: flex;
      }
    }
    .title-name{
      color: rgb(248,78,32);
      font-size: 28px;
      text-align: center;
      margin-top: 100px;
    }
  }

}
.new_foot {
  background-color: #4d4d4d;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.newFootSet {
  .special-foot {
    min-height: 164px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.logo_new {
  width: 170px;
  height: 60px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  /* background: url("../assets/par01.png"); */
}
.logoImage img {
  width: 170px;

  /* height: 70px; */
}
.us {
  width: 800px;
}
.flexclass {
  display: flex;
  margin-top: 15px;
}
.font-content {
  width: 653px;
  margin-left: 30px;
  line-height: 25px;
}
.flexclass > div {
  line-height: 30px;
}


.us {
  /* width: 50%; */
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>

<script>
import TopHeader from "../../../common/compoments/TopHeader";
import Footer from "../components/Footer.vue";
var imgSrc = [
  require("../assets/par01.png"),
  require("../assets/par02.png"),
  require("../assets/par03.png"),
  require("../assets/par04.png"),
  require("../assets/par05.png"),
  require("../assets/par06.png"),
  require("../assets/par07.png"),
  require("../assets/par08.png")
];
export default {
  name: "about",
  components: {
    TopHeader,
    Footer
  },
  data() {
    return {
      imgSrc: [
        require("../assets/par01.png"),
        require("../assets/par02.png"),
        require("../assets/par03.png"),
        require("../assets/par04.png"),
        require("../assets/par05.png"),
        require("../assets/par06.png"),
        require("../assets/par07.png"),
        require("../assets/par08.png")
      ],
      backgroundImage: [
        {
          backgroundImage: "url(" + require("../assets/par01.png") + ")"
        },
        {
          backgroundImage: "url(" + require("../assets/par02.png") + ")"
        },
        {
          backgroundImage: "url(" + require("../assets/par03.png") + ")"
        },
        {
          backgroundImage: "url(" + require("../assets/par04.png") + ")"
        },
        {
          backgroundImage: "url(" + require("../assets/par05.png") + ")"
        },
        {
          backgroundImage: "url(" + require("../assets/par06.png") + ")"
        },
        {
          backgroundImage: "url(" + require("../assets/par07.png") + ")"
        },
        {
          backgroundImage: "url(" + require("../assets/par08.png") + ")"
        }
      ]
    };
  },
  created: function() {},
  mounted: function() {
    // this.$nextTick().then(
    //   function() {
    //     var loginR = document
    //       .getElementsByClassName("right-selection")[0]
    //       .getElementsByTagName("div");
    //     loginR[0].className = "new_login new_login_bcon3";
    //     loginR[1].className = "new_login new_login_bcon4";
    //   }.bind(this)
    // );
  },
  methods: {
    leaveFn(e) {
      var mark = e + 1;
      this.backgroundImage[e].backgroundImage =
        "url(" + require(`../assets/par0${mark}.png`) + ")";
    },
    hoverFn(e) {
      var mark = e + 1;
      this.backgroundImage[e].backgroundImage =
        "url(" + require(`../assets/change0${mark}.png`) + ")";
    }
  }
};
</script>
